import { render, staticRenderFns } from "./activityNBAModule.html?vue&type=template&id=0c85767c&external"
import script from "./activityNBAModule.vue?vue&type=script&lang=js"
export * from "./activityNBAModule.vue?vue&type=script&lang=js"
import style0 from "./activityNBAModule.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports